import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import ToolSafetyDisclaimer from '../components/tools/ToolSafetyDisclaimer';
import PrechargeResistorCalculator from '../components/tools/PrechargeResistorCalculator';

const PrechargeResistorCalculatorPage = () => {
  return (
    <div className="min-h-screen" data-testid="precharge-resistor-calculator-page">
      <PageHero
        eyebrow="Engineering Utilities"
        title="HV Precharge Resistor Calculator"
        description="Size or check an EV HV precharge resistor from the X and Y capacitance of every component on the bus — precharge time, current, power, energy, contactor inrush and the precharge curve."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="precharge-resistor-calculator-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <PrechargeResistorCalculator />
          <ToolSafetyDisclaimer
            standards="a first-order RC precharge model with typical component values and the ISO 6469-3 0.2 J Y-capacitance limit"
            className="mt-10 text-[11px]"
            showTerms={false}
          />
          <ToolGuideCta guidePath="/tools/precharge-resistor-calculator/guide" toolName="HV Precharge Resistor Calculator" />
        </div>
      </section>
    </div>
  );
};

export default PrechargeResistorCalculatorPage;
